(function () {
  const input = document.getElementById("ml-search-q");
  const box = document.getElementById("ml-suggest");
  if (!input || !box) return;

  const LIMIT = 6;          // quantos produtos sugerir
  const MIN_CHARS = 1;      // 1 letra (igual Mercado Livre)
  const DEBOUNCE_MS = 180;  // velocidade

  let t = null;
  let lastQuery = "";

  function hide() {
    box.hidden = true;
    box.innerHTML = "";
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  async function fetchSuggest(q) {
    const url =
      `/search/suggest.json?q=${encodeURIComponent(q)}` +
      `&resources[type]=product` +
      `&resources[limit]=${LIMIT}` +
      `&resources[options][unavailable_products]=hide` +
      `&resources[options][fields]=title,product_type,variants.title`;

    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) return [];
    const data = await res.json();

    // caminhos comuns de retorno
    const products =
      data?.resources?.results?.products ||
      data?.resources?.results?.["products"] ||
      [];

    return Array.isArray(products) ? products : [];
  }

  function render(products) {
    if (!products.length) {
      box.innerHTML = `<div class="ml-suggest-empty">Nenhum produto encontrado.</div>`;
      box.hidden = false;
      return;
    }

    const html = products
      .map((p) => {
        const title = escapeHtml(p.title || "Produto");
        const url = p.url || "#";
        const img =
          p.featured_image?.url ||
          p.image ||
          "";

        const imgTag = img
          ? `<img src="${img}" alt="${title}" loading="lazy">`
          : `<div style="width:40px;height:40px;border-radius:8px;background:rgba(0,0,0,.06)"></div>`;

        return `
          <a href="${url}">
            ${imgTag}
            <div class="ml-suggest-title">${title}</div>
          </a>
        `;
      })
      .join("");

    box.innerHTML = html;
    box.hidden = false;
  }

  async function onType() {
    const q = input.value.trim();
    if (q.length < MIN_CHARS) return hide();
    if (q === lastQuery) return;

    lastQuery = q;

    try {
      const products = await fetchSuggest(q);
      // se o usuário digitou algo diferente no meio do fetch, não renderiza o antigo
      if (input.value.trim() !== q) return;
      render(products);
    } catch (e) {
      hide();
    }
  }

  input.addEventListener("input", () => {
    clearTimeout(t);
    t = setTimeout(onType, DEBOUNCE_MS);
  });

  document.addEventListener("click", (e) => {
    if (!box.contains(e.target) && e.target !== input) hide();
  });

  input.addEventListener("focus", () => {
    // reabrir se já tiver valor
    if (input.value.trim().length >= MIN_CHARS && box.innerHTML.trim()) {
      box.hidden = false;
    }
  });

  input.addEventListener("keydown", (e) => {
    if (e.key === "Escape") hide();
  });
})();
